"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getESTHour = void 0;
const get_EST_date_1 = require("../get-EST-date/get-EST-date");
/**
 * Returns the corresponding hour in EST
 * @public
 *
 * @param today - Date from where to calculate EST hour
 *
 * @returns Hour in EST
 */
function getESTHour(today) {
    const estDate = (0, get_EST_date_1.getESTDate)(today);
    return estDate.getHours();
}
exports.getESTHour = getESTHour;
//# sourceMappingURL=get-EST-hour.js.map